var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useAsyncAction } from "nate-react-api-helpers";
import { api } from "../../api/API";
import { useNavigate } from "react-router-dom";
import { TerrainModalFormat } from "./TerrainModalFormat";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ text: { width: 275 } }); });
export function Login() {
    var _this = this;
    var styles = useStyles().classes;
    var _a = useState(""), username = _a[0], setUsername = _a[1];
    var _b = useState(""), password = _b[0], setPassword = _b[1];
    var nav = useNavigate();
    var login = useAsyncAction(function (input) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.employees.login(input)];
                case 1:
                    _a.sent(); // @ts-ignore
                    window.location = "/";
                    return [2 /*return*/];
            }
        });
    }); }, []);
    return /*#__PURE__*/ _jsx(TerrainModalFormat, { onSubmit: function () { login.callback({ username: username, password: password }); }, inputs: /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(Grid, { children: /*#__PURE__*/ _jsx(TextField, { onChange: function (e) { return setUsername(e.target.value); }, className: styles.text, label: "Email" }) }), /*#__PURE__*/ _jsx(Grid, { children: /*#__PURE__*/ _jsx(TextField, { onChange: function (e) { return setPassword(e.target.value); }, type: "password", className: styles.text, label: "Password" }) })] }), actions: /*#__PURE__*/ _jsxs(_Fragment, { children: [login.LoadingElement && /*#__PURE__*/ _jsxs(_Fragment, { children: [login.LoadingElement, /*#__PURE__*/ _jsx("div", { style: { height: 30 } })] }), /*#__PURE__*/ _jsxs(Grid, { container: true, sx: { justifyContent: "space-between" }, children: [/*#__PURE__*/ _jsx(Grid, { children: /*#__PURE__*/ _jsx(Button, { onClick: function () { return nav("/forgot-password"); }, children: "Forgot Password" }) }), /*#__PURE__*/ _jsx(Grid, { children: /*#__PURE__*/ _jsx(Button, { variant: "contained", color: "primary", type: "submit", children: "Login" }) })] })] }) });
}
